import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum DenimTearsPOV2LineItemKeys {
  goodOrService = 'goodOrService', // Good or Service description
  product = 'product', // Product name
  sku = 'sku', // SKU or item code
  styleNumber = 'styleNumber',
  size = 'size',
  color = 'color',
  price = 'price', // Price per unit
  qty = 'qty', // Quantity
  amount = 'amount', // Total amount (price * qty)
}

export const denimTearsPurchaseOrderV2FileDataSchema = yup.object().shape({
  buyer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  purchaseOrderNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  vendorName: yup.string().nullable().optional(),
  billTo: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  deliverTo: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        goodOrService: yup.string().nullable().optional(),
        product: yup.string().nullable().optional(),
        sku: yup.string().nullable().optional(),
        styleNumber: yup.string().nullable().optional(),
        size: yup.string().nullable().optional(),
        color: yup.string().nullable().optional(),
        price: yup.string().nullable().optional(),
        qty: yup.string().nullable().optional(),
        amount: yup.string().nullable().optional(),
      }),
    )
    .required(),
  taxRate: yup.string().nullable().optional(),
  notes: yup.string().nullable().optional(),
})

export type DenimTearsPurchaseOrderV2FileData = yup.InferType<
  typeof denimTearsPurchaseOrderV2FileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<DenimTearsPurchaseOrderV2FileData>

export const denimTearsPurchaseOrderV2FileMappings: RequiredFileData = {
  buyer: {
    companyName: '64d8cf64-0ded-4d9a-9789-f1ccef6b4f54',
    emailAddress: 'ff482b87-9517-48d8-b910-16375e709094',
  },
  purchaseOrderNumber: '41c1fa50-df51-4818-9db2-74c771c97444',
  dateIssued: 'fe3859ea-1bd9-48ae-a5d1-214b3b218d0a',
  vendorName: 'de79ce34-f919-4507-834d-aaaa3a0991c8',
  billTo: {
    companyName: 'f079edfa-d28b-4286-8d70-8d8ec5545ef5',
    address: 'ef18496c-23ec-40fb-a545-e0baf63ec87e',
    contactName: 'b5d8fb80-33ae-44f0-ad58-c8b6a31aa594',
    phoneNumber: '514c6d9b-1d0e-4a3d-9d2a-2f7d5ad436a9',
    emailAddress: '182dbf0e-3671-400a-88cb-36bbed4812d5',
  },
  deliverTo: {
    companyName: '44960525-b16d-4530-b314-9416a2a86da3',
    address: 'f3a32391-9e8f-4a11-adb9-eaf8776e786e',
    contactName: 'e4819841-8985-4d74-94ec-2b22d68f812b',
    phoneNumber: '853349ca-587a-4282-976c-c54e447b916a',
    emailAddress: '8f9b83af-2bb5-4d08-9488-96c19b0bed25',
  },
  items: [
    {
      goodOrService: '3df9c99f-8db7-46be-a383-a420563b72ee',
      product: '920f1a29-d185-412e-8573-392594042fba',
      sku: 'a6e67798-c0f3-4502-955a-9146e5f6cac0',
      styleNumber: '0c1ec0c5-047e-437d-a2b9-4f447384b6c5',
      size: '2aa78e86-e23c-4650-a73d-d65da8014b9b',
      color: 'd4d1d2b9-bc02-4fb8-91c4-e97dc3a6332c',
      price: '6d60e663-5508-49ef-a2b1-d69f1b3c5fea',
      qty: 'be38aaab-2701-4b37-8f56-ac2cb654a218',
      amount: null,
    },
  ],
  taxRate: 'f0f62514-065c-4f37-a843-ab65256f5686',
  notes: '514b889c-6933-41f1-be2c-089720991a56',
}
